module.exports = "/deep/ .mat-dialog-content{display:contents !important}/deep/ .mat-dialog-container{overflow:hidden !important}\n"